import { Card, Col, Image } from "antd";
import "./style.less";
import { IFile } from "../../../../services/File";

interface ImagenItemProps {
  imagen: IFile;
}

const ImagenItem: React.FC<ImagenItemProps> = ({ imagen }) => {
  const { filename, file, mimetype }: IFile = imagen;

  if (!file) return <></>;

  return (
    <div className="ImagenItem">
      <Card>
        <Col span="24">
          <p>{filename}</p>
          <Image
            max-height="60vh"
            src={`data:${mimetype};base64,${file}`}
            preview={{ getContainer: "#root" }}
          />
        </Col>
      </Card>
    </div>
  );
};

export default ImagenItem;
